import { render, staticRenderFns } from "./curriculumTeacherChoose.vue?vue&type=template&id=737df321&scoped=true"
import script from "./curriculumTeacherChoose.vue?vue&type=script&lang=js"
export * from "./curriculumTeacherChoose.vue?vue&type=script&lang=js"
import style0 from "./curriculumTeacherChoose.vue?vue&type=style&index=0&id=737df321&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737df321",
  null
  
)

export default component.exports